import React from 'react';

export const EmptyItem = (): JSX.Element => (
  <div className="empty-item">There are no items to show in this category</div>
);
